// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2dc7d1a9","160":"8a2c0709","208":"6e01bf83","293":"a2998200","453":"f4493c00","516":"6cbebe67","519":"d9c8a570","917":"f3c9c350","946":"3b07ab33"}[chunkId] + ".chunk.js";
};